import React from 'react';

import {
  Button,
  Stack
} from '@mui/material';
import _ from 'lodash';
import {
  authService,
  BaseOnboardingTemplate,
  LoadingOverlay,
  routeDirectory,
  UserTypeSelectionCard
} from 'modules';
import { baseTypes } from 'modules';
import { useNavigate } from 'react-router-dom';

import * as dataService from './dataService';



export interface IOnboardingUserTypeActivityProps {}

export const OnboardingUserTypeActivity: React.FC<IOnboardingUserTypeActivityProps> = props => {
  const [userType, setUserType] = React.useState<baseTypes.IUserType>('notSet');
  const { mutations, loading, data } = dataService.useQuery();
  const navigate = useNavigate();



  React.useEffect(() => {
    if (!loading && data.userTypeName) {
      setUserType(data.userTypeName);
    }
  }, [data, loading]);



  return (
    <BaseOnboardingTemplate.FC
      stepperMode="userType"
      title="Select User Type"
      subtitle="Choose the user type that best represents you.">
      <LoadingOverlay active={loading} />
      <Stack spacing={7}>
        <Stack
          direction="row"
          spacing={3}>

          <UserTypeSelectionCard.FC
            isSelected={userType === 'startupFounder'}
            variant="startupFounder"
            onClick={_.partial(setUserType, 'startupFounder')} />

          <UserTypeSelectionCard.FC
            isSelected={userType === 'investor'}
            variant="investor"
            onClick={_.partial(setUserType, 'investor')} />
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between">
          <Button
            variant="outlined"
            color="secondary"
            onClick={async () => {
              await authService.logOut();
              navigate(routeDirectory.authentication.login.path(), { replace: true });
            }}>
            Back
          </Button>

          <Button
            disabled={userType === 'notSet' || loading}
            onClick={async () => {
              if (userType !== 'notSet') {
                await mutations.saveUserType(userType);
                if (data.allAccessEnabled) {
                  navigate(routeDirectory.home.path());
                } else {
                  navigate(routeDirectory.authentication.onboardingProfile.path());
                }
              }
            }}>
            Next
          </Button>
        </Stack>
      </Stack>
    </BaseOnboardingTemplate.FC>
  );
};
